import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { getRoundFromIdAtom } from "../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";
import { RoundControls_Booking$key } from "./__generated__/RoundControls_Booking.graphql";
import { DurationRoundControls } from "./components/DurationRoundControls/DurationRoundControls";
import { GolfRoundControls } from "./components/GolfRoundControls/GolfRoundControls";

type Props = {
  roundId: string;
  bookingRef: RoundControls_Booking$key;
  currentMembershipTypeId: string;
};
/**
 *
 * Responsible for selecting which broad bundle of controls to show.
 *
 * @TODO will need to make pivots once we extend to other bookings types
 */
export const RoundControls = ({
  roundId,
  bookingRef,
  currentMembershipTypeId,
}: Props) => {
  const booking = useFragment(RoundControlsFragmentString, bookingRef);

  const isLessonBooking = booking.__typename === "LessonBooking";

  const round = useAtomValue(getRoundFromIdAtom(roundId));

  if (isLessonBooking || round?.isNonPlayingHost) {
    return null;
  }

  const isDurationBasedFacility =
    booking?.startSlot?.agenda?.facility.type &&
    booking?.startSlot?.agenda?.facility.type !== "GOLF_COURSE";

  return isDurationBasedFacility ? (
    <DurationRoundControls
      bookingRef={booking}
      roundId={roundId}
      currentMembershipTypeId={currentMembershipTypeId}
    />
  ) : (
    <GolfRoundControls bookingRef={booking} roundId={roundId} />
  );
};

const RoundControlsFragmentString = graphql`
  fragment RoundControls_Booking on Booking {
    __typename
    ...GolfRoundControls_Booking
    ...DurationRoundControls_Booking
    startSlot {
      agenda {
        facility {
          type
        }
      }
    }
  }
`;
